import { SigningFlowState } from './signingTypes';

export const initialState = {
    signingOperationPending: false,
    showSigningFlow: false,
} as SigningFlowState;
